import NPM from '#ui/Icons/PackageManager/Npm';
import PNPM from '#ui/Icons/PackageManager/Pnpm';
import YARN from '#ui/Icons/PackageManager/Yarn';

export { NPM, PNPM, YARN };
